export const FILTERED_GITLAB_REPOS = 'FILTERED_GITLAB_REPOS';

export const filteredGitLabRepos = (data) => {
	return {
		type: FILTERED_GITLAB_REPOS,
		filteredRepos: data
	}
};
